import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  risk: null,
  riskStatus: IDLE,

  riskHistory: null,
  riskHistoryStatus: IDLE,

  riskOrganizations: [],
  riskOrganizationsStatus: IDLE,

  riskConnectedPolicies: [],
  riskConnectedPoliciesStatus: IDLE,

  createRiskStatus: IDLE,
  updateRiskStatus: IDLE,
  deleteRiskStatus: IDLE
};

const riskSlice = createSlice({
  name: 'risk',
  initialState,
  reducers: {
    getRisk(state) {
      state.riskStatus = LOADING;
    },
    getRiskSucceeded(state, action) {
      state.riskStatus = SUCCEEDED;
      state.risk = action.payload;
    },
    getRiskFailed(state) {
      state.riskStatus = FAILED;
    },

    clearRisk(state) {
      state.risk = null;
      state.riskStatus = IDLE;
    },

    getRiskHistory(state) {
      state.riskHistoryStatus = LOADING;
    },
    getRiskHistorySucceeded(state, action) {
      state.riskHistoryStatus = SUCCEEDED;
      state.riskHistory = action.payload;
    },
    getRiskHistoryFailed(state) {
      state.riskHistoryStatus = FAILED;
    },

    clearRiskHistory(state) {
      state.riskHistory = null;
      state.riskHistoryStatus = IDLE;
    },

    getRiskOrganizations(state) {
      state.riskOrganizationsStatus = LOADING;
    },
    getRiskOrganizationsSucceeded(state, action) {
      state.riskOrganizations = action.payload;
      state.riskOrganizationsStatus = SUCCEEDED;
    },
    getRiskOrganizationsFailed(state) {
      state.riskOrganizationsStatus = FAILED;
    },

    getRiskConnectedPolicies(state) {
      state.riskConnectedPoliciesStatus = LOADING;
    },
    getRiskConnectedPoliciesSucceeded(state, action) {
      state.riskConnectedPoliciesStatus = SUCCEEDED;
      state.riskConnectedPolicies = action.payload;
    },
    getRiskConnectedPoliciesFailed(state) {
      state.riskConnectedPoliciesStatus = FAILED;
    },

    clearRiskConnectedPolicies(state) {
      state.riskConnectedPolicies = [];
      state.riskConnectedPoliciesStatus = IDLE;
    },

    createRisk(state) {
      state.createRiskStatus = LOADING;
    },
    createRiskSucceeded(state) {
      state.createRiskStatus = SUCCEEDED;
    },
    createRiskFailed(state) {
      state.createRiskStatus = FAILED;
    },

    updateRisk(state) {
      state.updateRiskStatus = LOADING;
    },
    updateRiskSucceeded(state) {
      state.updateRiskStatus = SUCCEEDED;
    },
    updateRiskFailed(state) {
      state.updateRiskStatus = FAILED;
    },

    deleteRisk(state) {
      state.deleteRiskStatus = LOADING;
    },
    deleteRiskSucceeded(state) {
      state.deleteRiskStatus = SUCCEEDED;
    },
    deleteRiskFailed(state) {
      state.deleteRiskStatus = FAILED;
    }
  }
});

export const {
  getRisk,
  getRiskSucceeded,
  getRiskFailed,
  clearRisk,
  getRiskHistory,
  getRiskHistorySucceeded,
  getRiskHistoryFailed,
  clearRiskHistory,
  getRiskOrganizations,
  getRiskOrganizationsSucceeded,
  getRiskOrganizationsFailed,
  getRiskConnectedPolicies,
  getRiskConnectedPoliciesSucceeded,
  getRiskConnectedPoliciesFailed,
  clearRiskConnectedPolicies,
  createRisk,
  createRiskSucceeded,
  createRiskFailed,
  updateRisk,
  updateRiskSucceeded,
  updateRiskFailed,
  deleteRisk,
  deleteRiskSucceeded,
  deleteRiskFailed
} = riskSlice.actions;

export default riskSlice.reducer;
